export const DEFAULT_OVERLAY_FIELD_CONTAINER_Z_INDEX = 2;
export const OPEN_OVERLAY_FIELD_CONTAINER_Z_INDEX = 100;
